import config from "common/config/config";
import { AppCurrency } from "../Balance.types";

export const CURRENCY_UNIT: Record<AppCurrency, string> = {
    nativeToken: config.tokenNames.nativeToken,
    cop: "$",
};
